var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"btn",class:[{subscribed: _vm.isSubscribed}, {boxed: _vm.border}],on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[(_vm.isSubscribed)?_c('i',{staticClass:"fa fa-bell"}):_c('i',{staticClass:"far fa-bell"})])
}
var staticRenderFns = []

export { render, staticRenderFns }